import FBody from '@/plugins/form/FBody';
import FInputFio from '@/plugins/form/FInputFio';
import FInput from '@/plugins/form/FInput';
import FDate from '@/plugins/form/FDate';
import FSelect from '@/plugins/form/FSelect';

import component from './component.vue';
import FDictionaryCitizenship from '@/modules/Dictionary/Citizenship/Select';

export default class extends FBody {
  component = component;

  fio = new FInputFio({
    label: 'ФИО',
    required: true,
  });

  birthday = new FDate({
    label: 'День рождения',
    required: true,
  });

  documentType = new FSelect({
    label: 'Тип документа',
    show: true,
  });

  documentNumber = new FInput({
    label: 'Серия и номер',
    show: true,
  });

  documentFrom = new FDate({
    label: 'Выдан',
    show: true,
  });

  age = new FSelect({
    label: 'Возраст',
    options: [
      {
        value: 0,
        label: 'Взрослый',
      },
      {
        value: 1,
        label: 'Ребенок',
      },
      {
        value: 2,
        label: 'Младенец',
      },
    ],
    show: false,
  });

  gender = new FSelect({
    label: 'Пол',
    options: [
      {
        value: 'MAN',
        label: 'Мужской',
      },
      {
        value: 'WOMAN',
        label: 'Женский',
      },
    ],
  });

  citizenship = new FDictionaryCitizenship({
    label: 'Гражданство',
    showAdd: false,
    show: true,
  });

  id = null;

  email = new FInputFio({
    label: 'Email',
    required: true,
  });

  phone = new FInputFio({
    label: 'Телефон',
    required: true,
  });

  constructor(props) {
    super(props);
    this.setItems([
      ['fio', this.fio],
      ['age', this.age],
      ['gender', this.gender],
      ['birthday', this.birthday],
      ['citizenship', this.citizenship],
      ['documentType', this.documentType],
      ['documentNumber', this.documentNumber],
      ['documentFrom', this.documentFrom],
    ]);
  }

  get data() {
    return {
      Id: this.id,
      FirstName: this.fio.firstName,
      LastName: this.fio.name,
      MiddleName: this.fio.middleName,
      DateOfBirth: {
        Serialized: this.birthday.toString(),
      },
      IsTourist: true,
      IsMain: false,
      DocumentNumber: this.documentNumber.value,
      DocumentValidDate: null,
      Email: this.email.value,
      ContactTelephoneNumber: this.phone.value,
      DocumentDateOfIssuance: {
        Serialized: this.documentFrom.toString(),
      },
      TypeOfDocument: this.documentType.toValue(),
      Gender: this.gender.toValue(),
      AgeCategory: this.age.toValue(),
    };
  }
}
